// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3t7cg","label":"Radio_label__1io0y","checkMark":"Radio_checkMark__gSLSy","disabled":"Radio_disabled__gtkdU"};